// extracted by mini-css-extract-plugin
module.exports = {"sku":"zSJEVM-2cTnPLxxsjHb8X","active":"_2h8OJkMDnHW75wYMOF3Osm","tick":"_9z_J8I-yBzrI7RztTpVEu"};